import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Alert from '../../../ui/Alert';
import styles from './css/LabelDownload.scss';
import {FormattedMessage} from 'react-intl';
import Button from '../../../ui/Button';

export default class LabelDownload extends Component {

    static propTypes = {
        order: PropTypes.object,
        size: PropTypes.string,
    }
    static sizes = {
        DEFAULT: 'default',
        SMALL: 'small',
    };

    renderDownloadButton() {
        const {order, size} = this.props;

        const labelIsReady = !!order.getIn(['labelStatus', 'generated'], false);
        if (labelIsReady) {
            if (size === LabelDownload.sizes.SMALL) {
                // Small sized component used in order details
                return (
                    <a href={order.getIn(['labelStatus', 'path'])}>
                        <Button emphasis='primary' block >
                            <i className='fa fa-download'/>
                        </Button>
                    </a>
                );
            }

            return (
                <a href={order.getIn(['labelStatus', 'path'])}>
                    <Button emphasis='primary' block >
                        <FormattedMessage id='frontend.form_confirmation.button.button_label'/>
                    </Button>
                </a>
            );
        }

        if (order.getIn(['labelStatus', 'error'])) {
            return (
                <Alert type='warning'>
                    <FormattedMessage id='frontend.form_confirmation.text.label_failed'/>
                </Alert>
            );
        }

        return (
            <Button emphasis='primary' loading disabled block>
                <FormattedMessage id='common.helper.please_wait'/>
            </Button>
        );
    }

    render() {
        const {order, size} = this.props;

        if (!order.getIn(['labelStatus', 'required'], false)) {
            return null;
        }

        const smallSized = (size === LabelDownload.sizes.SMALL);

        const labelError = order.getIn(['labelStatus', 'error']);
        const labelDownloaded = !!order.getIn(['labelStatus', 'downloaded'], false);

        if (!labelError) {
            return (
                <Alert type={smallSized ? 'default' : 'info'} className={styles.block}>
                    <div className='alert alert--warning'>
                        {(!smallSized && <h4>
                            <FormattedMessage id={'frontend.form_confirmation.headline.thanks_pickup'}/>
                        </h4>)}
                        {(!smallSized || !labelDownloaded) && <p>
                            <FormattedMessage id={'frontend.form_confirmation.text.pickup_message'}/>
                        </p>}

                        {this.renderDownloadButton()}
                    </div>
                </Alert>
            );
        }

        return (
            <Alert type='warning' className={styles.block}>
                {labelError}
            </Alert>
        );
    }

}
